<template>
  <div class="orderAction">
    <div class="mask"></div>
    <div class="main">
      <div @click="close" class="close"><i class="iconfont icon-cha"></i></div>
      <h2>确认预约</h2>
      <ul>
        <li>
          <div>联系人</div>
          <div>当前状态</div>
          <div>可预约人数</div>
          <div>已预约人数</div>
          <div>联系方式</div>
          <div>地点</div>
          <div>操作</div>
        </li>
        <li v-for="item in userList">
          <div>{{item.username}}</div>
          <div>{{item.status | getStatusDesc}}</div>
          <div>{{item.freeCount}}</div>
          <div>{{item.holdCount}}</div>
          <div>{{item.tel}}</div>
          <div>{{item.address}}</div>
          <div><button :class="{'disable':!(item.status===2||item.status===3)}" @click="orderActionInit(item)">{{(item.status===2||item.status===3)?'预约':'不可预约'}}</button></div>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
  //axios
  import axios from 'axios'
  import apiConfig from 'common/js/api_config'
  import {deepClone} from "common/js/deepClone";

  export default {
    name: "orderAction",
    props:{
      handleData:{
        type:Object
      }
    },
    data() {
      return {
        userList:[]
      }
    },
    computed: {},
    methods: {
      async _initOrderDetail(){
        let orderDetail=await axios.post(apiConfig.REQUEST_URL+'/shall/front_getOrderDetail?' + this.$qs.stringify({
          sysId: this.handleData.sysId,
          day: this.handleData.day,
          type: this.handleData.type
        }))
        if(orderDetail.data.status){
          this.userList=orderDetail.data.data
        }
      },
      close(){
        this.$emit('close')
      },
      async orderActionInit(item){

        if(!(item.status===2 || item.status===3)){
          this.$notify({
            group: "global",
            title: "温馨提示",
            text: "不可预约"
          });
          return
        }

        let requestData=deepClone(this.handleData)
        requestData.anon=1
        requestData.managerId=item.managerId

        let orderResult=await axios.post(apiConfig.REQUEST_URL+'/shall/front_order?' + this.$qs.stringify({
          sysId: requestData.sysId,
          day: requestData.day,
          type: requestData.type,
          anon: requestData.anon,
          managerId: requestData.managerId
        }))
        this.$notify({
          group: "global",
          title: "温馨提示",
          text: orderResult.data.msg
        });
        if(orderResult.data.status){
          this.$emit('orderFinish')
        }
      }
    },
    filters:{
      getStatusDesc(val){
        switch (val) {
          case 0:
            return '不可预约'
          case 1:
            return '预约已满'
          case 2:
            return '可预约'
          case 3:
            return '预约过半'
          case 4:
            return '已经预约'
        }
      }
    },
    mounted() {
      this._initOrderDetail()
    }
  }
</script>

<style lang="stylus" scoped>
  @import "~common/stylus/config.styl"
.orderAction

  .mask
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    background rgba(0, 0, 0, 0.5)
    width 100%
    height 100%

  .main
    overflow visible
    padding 20px
    color #666666
    font-size 14px
    box-shadow 3px 3px 3px #666
    position absolute
    left 0
    right 0
    top 0
    bottom 0
    margin auto
    width 800px
    height 500px
    background #f1f1f1
    z-index 999
    .close
      width 40px
      height 40px
      line-height 40px
      text-align center
      right -50px
      top -50px
      border-radius 50%
      background #f1f1f1
      box-shadow 3px 3px 3px #666
      position absolute
      i
        font-size 20px
    &>h2
      font-size 16px
      text-align center
      margin-bottom 30px
    &>ul
      li
        padding 10px
        border-bottom 1px solid #cccccc
        margin-top 10px
        font-size 0
        div
          text-align center
          font-size 14px
          width 14.28%
          display inline-block
          &>button
            width 100px
            height 24px
            border-radius 12px
            border none
            outline none
            color #ffffff
            background #004a94
            transition 300ms
            &:hover
              background #007DEE
            &.disable
              background-color #cccccc !important
</style>



// WEBPACK FOOTER //
// src/components/order/orderAction.vue